import Popup from 'reactjs-popup';
import Select from 'react-select'
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import { useAuthState } from '../../../../../../Helper/Context';
import { useDispatch } from 'react-redux';
import { WTPPumpMasterPostDataAPI } from '../../../../../../Redux/WTPDashboardSlice/WTPDashboardsSlice/WTPMasterData/WTPPumpMasterSlice';
import { WTPSumpNumberDDL } from '../../../../../../Components/CommonDDL/WTPSumpNumberDDL';
import { WTPPumpCategoryNoDDL } from '../../../../../../Components/CommonDDL/WTPPumpCategoryDDL';


export default function WTPPumpMasterPagePopup(props) {

    const { handleOnCloseClick, open, Flag, handleIsPost, apiFlag, rowData } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [PumpNumberDDL, setPumpNumberDDL] = useState(Flag === 'Update' ? rowData.pumpNumber : '')

    const [Category, setCategory] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_wtP_PumpCategoryID : '0',
        Label: Flag === 'Update' ? rowData.pumpCategory : '0',
    })

    const [SumpNumber, setSumpNumber] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_wtP_SumpID : '0',
        Label: Flag === 'Update' ? rowData.sumpNumber : '0',
    })

    const handlePost = () => {
        const data = {
            M_WTP_PumpID: Flag === 'Update' ? rowData.m_wtP_PumpID : '0',
            M_WTP_PumpCategoryID: Category.ID,
            M_WTP_SumpID: SumpNumber.ID,
            PumpNumber:PumpNumberDDL,
            M_UserID: UserID,
            token: token,
            Flag: Flag === 'Update' ? 'Update' : 'Insert',
            handleIsPost: handleIsPost,
            handleOnCloseClick: handleOnCloseClick
        }
        dispatch(WTPPumpMasterPostDataAPI({ data }))

    }


    return (

        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >
            <div className="area_pop modal-dialog modal-dialog-scrollable modal-xl" style={{ alignItems: "center", justifyContent: 'center' }}>
                <div className="modal-content road_ward_modal">
                    <div className="modal-header pl-4 p-1">
                        <h4 className="modal-title" id="staticBackdropLabel">Pump Master</h4>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>
                    <div className="modal-body">
                        <div className='inner-modal-body'>
                            <div className="row details-row">
                                <div className="col-lg-6 col-md-6">
                                    <WTPPumpCategoryNoDDL
                                        Category={Category}
                                        setCategory={setCategory}
                                        rowData={rowData}
                                        Flag={Flag}
                                    />

                                </div>
                                <div className="col-lg-6 col-md-6">
                                    <WTPSumpNumberDDL
                                        SumpNumber={SumpNumber}
                                        setSumpNumber={setSumpNumber}
                                        PlantName='0'
                                    // Flag='ward'
                                    />

                                </div>

                                <div className="col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Pump Number </b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="PumpNumberDDL"
                                            name='PumpNumberDDL'
                                            value={PumpNumberDDL}
                                            onChange={(e) => setPumpNumberDDL(e.target.value)}
                                        />

                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-12">
                                <div className="btn-action d-flex justify-content-end mt-lg-3">
                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                    onClick={() => handlePost()}
                                    >{Flag === "Update" ? "Update" : "Save"} </button>
                                    <button type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* )} */}
        </Popup>
    )

}